import React from "react";
import dayjs from "dayjs";
import { Modal, Table, Tag } from "antd";

const formatDate = (value) => dayjs(value).format("MM/DD/YYYY hh:mm A");

// Shows the history of the changes of the assigned date of a shift
const DriverShiftHistoryModal = ({ open, onClose, shift }) => {
	// Shifts created before the history existed only have their creation
	const history =
		shift?.history?.length > 0
			? shift.history
			: shift
			? [
					{
						status: "Created",
						date: shift.rawDate,
						createdAt: shift.rawCreatedAt,
						createdBy: { name: shift.createdBy },
					},
			  ]
			: [];

	const columns = [
		{
			title: "#",
			key: "number",
			width: 50,
			render: (_, item, index) => index + 1,
		},
		{
			title: "Status",
			key: "status",
			render: (_, item, index) => {
				// History saved before the status existed: the first one is the creation
				const status = item.status || (index === 0 ? "Created" : "Moved Date");
				return <Tag color={status === "Created" ? "green" : "blue"}>{status}</Tag>;
			},
		},
		{
			title: "Assigned Date",
			key: "date",
			render: (_, item) => formatDate(item.date),
		},
		{
			title: "Changed At",
			key: "createdAt",
			render: (_, item) => (item.createdAt ? formatDate(item.createdAt) : "-"),
		},
		{
			title: "Changed By",
			key: "createdBy",
			render: (_, item) => item.createdBy?.name ?? "-",
		},
	];

	return (
		<Modal
			title="Shift Date History"
			open={open}
			onCancel={onClose}
			centered
			width={800}
			footer={null}
		>
			<Table
				columns={columns}
				dataSource={history.map((item, index) => ({ ...item, key: index }))}
				pagination={false}
				size="small"
				scroll={{ x: true }}
				locale={{ emptyText: "No history" }}
			/>
		</Modal>
	);
};

export default DriverShiftHistoryModal;
